import {
  addDays,
  addMonths,
  differenceInCalendarISOWeeks,
} from 'date-fns/esm/fp';

import { fromCents } from '#src/lib/formatters/numbers';
import { formatCalendarDate } from '#src/lib/formatters/temporal';

import { getRebillString } from '../../../common/helpers/get-rebill-string.js';
import { getTotalHeadingString } from '../../../common/helpers/get-total-heading-string.js';

import styles from './styles.module.scss';

const getSubscriptionEndDate = ({ duration }) => {
  if (duration.unit == 'day')
    return formatCalendarDate(addDays(duration.value, new Date()));
  else if (duration.unit == 'month')
    return formatCalendarDate(addMonths(duration.value, new Date()));
};

const getSubscriptionTitle = ({ duration }) => {
  return `${duration.value}-${duration.unit} plan`;
};

export const Total = ({ subscription }) => {
  if (!subscription?.duration) {
    return null;
  }

  const today = formatCalendarDate(new Date());
  const subscriptionEndDate = getSubscriptionEndDate(subscription);
  const difference = differenceInCalendarISOWeeks(
    new Date(today),
    new Date(subscriptionEndDate)
  );
  const pricePerWeek = difference != 0 ? subscription.amount / difference : 0;
  return (
    <div>
      <div className={styles.container}>
        <h3 className={styles.heading}>
          {getTotalHeadingString(subscription)}
        </h3>
        <div className={styles.items}>
          <strong className={styles.text}>
            {getSubscriptionTitle(subscription)}
          </strong>
          <strong className={styles.text}>
            {fromCents(pricePerWeek) + '/week'}
          </strong>
        </div>
      </div>
    </div>
  );
};

export const TotalFootnote = ({ subscription }) => {
  const rebillString = getRebillString(subscription);
  return !rebillString ? null : (
    <div className={styles.subtext}>*{rebillString}</div>
  );
};
